const REGISTER_KINDS = {
  en: {
    Cash: 'Cash',
    Cashless: 'Cashless',
    Bank: 'Bank',
    'Card Account': 'Card Account',
  },
  uk: {
    Cash: 'Готівка',
    Cashless: 'Термінал',
    Bank: 'Банківський рахунок',
    'Card Account': 'Картковий рахунок',
  },
};

export const FiscalizationCashiers = {
  en: {
    ...REGISTER_KINDS.en,
    'Fiscal accounts': 'Fiscal accounts',
    'Fiscal account': 'Fiscal account',
    'Create fiscal account': 'Create fiscal account',
    Login: 'Login',
    Location: 'Location',
    'Cash registers': 'Cash registers',
    'Fiscalization active': 'Fiscalization active',
    VAT: 'VAT',
    Shift: 'Shift',
    'Shift open': 'Shift open',
    'Shift closed': 'Shift closed',
  },
  uk: {
    ...REGISTER_KINDS.uk,
    'Fiscal accounts': 'Фіскальні акаунти',
    'Fiscal account': 'Фіскальний акаунт',
    'Create fiscal account': 'Створити фіскальний акаунт',
    Login: 'Логін',
    Location: 'Локація',
    'Cash registers': 'Каси',
    'Fiscalization active': 'Фіскалізація увімкнена',
    VAT: 'ПДВ',
    Shift: 'Зміна',
    'Shift open': 'Зміну відкрито',
    'Shift closed': 'Зміну закрито',
  },
};

export const FiscalizationCashierForm = {
  en: {
    ...FiscalizationCashiers.en,
    'New Fiscal account': 'New fiscal account',
    'Edit Fiscal account': 'Edit fiscal account',
    'Create Fiscal account': 'Create fiscal account',
    'Update Fiscal account': 'Update fiscal account',
    Password: 'Password',
    'License key': 'License key',
    'Not selected': 'Not selected',
    'Cash register (cash)': 'Cash register (cash)',
    'Cash register (terminal)': 'Cash register (terminal)',
    'Fiscal account name hint':
      'The name this account is shown under in the lists and at the desk.',
    'Fiscal account location hint':
      'Online serves the online channel, a physical location serves its desk. Head Office takes no money, so it cannot hold a fiscal account.',
    'Fiscal account login hint': 'The login of the Checkbox cashier account.',
    'Fiscal account password hint':
      'The password of the Checkbox cashier account.',
    'Fiscal account password edit hint':
      'Leave blank to keep the stored password.',
    'Fiscal account license key hint':
      'The license key of the cash register in Checkbox.',
    'Fiscal account cash register hint':
      'The register cash payments land in. One per account, on the same location.',
    'Fiscal account cashless register hint':
      'The register terminal and online payments land in. One per account, on the same location.',
    'Fiscal account active hint':
      'Sales paid on the linked registers are fiscalized. With it off nothing is sent to the provider.',
    'Fiscal account vat hint': 'Receipt lines carry VAT.',
  },
  uk: {
    ...FiscalizationCashiers.uk,
    'New Fiscal account': 'Новий фіскальний акаунт',
    'Edit Fiscal account': 'Редагування фіскального акаунта',
    'Create Fiscal account': 'Створити фіскальний акаунт',
    'Update Fiscal account': 'Оновити фіскальний акаунт',
    Password: 'Пароль',
    'License key': 'Ліцензійний ключ',
    'Not selected': 'Не вибрано',
    'Cash register (cash)': 'Каса (готівка)',
    'Cash register (terminal)': 'Каса (термінал)',
    'Fiscal account name hint':
      'Назва, під якою акаунт видно у списках і на ресепшні.',
    'Fiscal account location hint':
      'Online обслуговує онлайн-продажі, фізична локація — свій ресепшн. Head Office не приймає гроші, тому фіскального акаунта там бути не може.',
    'Fiscal account login hint': 'Логін касира в Checkbox.',
    'Fiscal account password hint': 'Пароль касира в Checkbox.',
    'Fiscal account password edit hint':
      'Залиште порожнім, щоб не змінювати збережений пароль.',
    'Fiscal account license key hint': 'Ліцензійний ключ каси в Checkbox.',
    'Fiscal account cash register hint':
      'Каса, у яку йде готівка. Одна на акаунт, на тій самій локації.',
    'Fiscal account cashless register hint':
      'Каса, у яку йдуть оплати терміналом та онлайн. Одна на акаунт, на тій самій локації.',
    'Fiscal account active hint':
      'Продажі, оплачені привʼязаними касами, фіскалізуються. Якщо вимкнено — до провайдера нічого не йде.',
    'Fiscal account vat hint': 'Позиції чека проводяться з ПДВ.',
  },
};

export const Fiscalization = {
  en: {
    'Cash register shifts': 'Cash register shifts',
    'Fiscalization desk hint':
      'Shift and reports of the fiscal accounts of your locations.',
    'No active fiscal accounts':
      'There are no active fiscal accounts on your locations.',
    'Shift open': 'Shift open',
    'Shift closed': 'Shift closed',
    'Open shift': 'Open shift',
    'Open shift confirm':
      'The provider will open a fiscal shift on this account.',
    'Close shift': 'Close shift',
    'Close shift confirm':
      'The provider will close the shift and answer with its Z report.',
    'Refresh status': 'Refresh status',
    'X report': 'X report',
    TypedReport: '{{type}} report',
    'Fiscal report details': 'Fiscal report details',
  },
  uk: {
    'Cash register shifts': 'Зміни на касах',
    'Fiscalization desk hint':
      'Зміна та звіти фіскальних акаунтів ваших локацій.',
    'No active fiscal accounts':
      'На ваших локаціях немає активних фіскальних акаунтів.',
    'Shift open': 'Зміну відкрито',
    'Shift closed': 'Зміну закрито',
    'Open shift': 'Відкрити зміну',
    'Open shift confirm': 'Провайдер відкриє фіскальну зміну на цьому акаунті.',
    'Close shift': 'Закрити зміну',
    'Close shift confirm': 'Провайдер закриє зміну і поверне Z-звіт.',
    'Refresh status': 'Оновити статус',
    'X report': 'X-звіт',
    TypedReport: '{{type}}-звіт',
    'Fiscal report details': 'Деталі фіскального звіту',
  },
};

export const FiscalizationReport = {
  en: {
    Status: 'Status',
    'Fiscalization report': 'Fiscalization report',
    'Fiscalization report hint':
      'Every receipt sent to the provider, and what the provider answered when one failed.',
    'Fiscal account': 'Fiscal account',
    'Receipt kind': 'Receipt kind',
    'Sale receipt': 'Sale receipt',
    'Return receipt': 'Return receipt',
    'Provider answer': 'Provider answer',
    'Created at': 'Created at',
    'Created from': 'Created from',
    'Created till': 'Created till',
    Source: 'Source',
    Order: 'Order',
    Transaction: 'Transaction',
    receipt_status_done: 'Fiscalized',
    receipt_status_pending: 'Pending',
    receipt_status_failed: 'Failed',
  },
  uk: {
    Status: 'Статус',
    'Fiscalization report': 'Звіт з фіскалізації',
    'Fiscalization report hint':
      'Усі чеки, відправлені провайдеру, і відповідь провайдера для тих, що не пройшли.',
    'Fiscal account': 'Фіскальний акаунт',
    'Receipt kind': 'Тип чека',
    'Sale receipt': 'Чек продажу',
    'Return receipt': 'Чек повернення',
    'Provider answer': 'Відповідь провайдера',
    'Created at': 'Створено',
    'Created from': 'Створено з',
    'Created till': 'Створено по',
    Source: 'Джерело',
    Order: 'Замовлення',
    Transaction: 'Транзакція',
    receipt_status_done: 'Фіскалізовано',
    receipt_status_pending: 'В обробці',
    receipt_status_failed: 'Помилка',
  },
};
